import React, { useEffect } from 'react';
import { AddFieldType } from './worksheet-form-component-edit-modal';
import { createUseStyles } from 'react-jss';
import { DraggableWorksheetFormComponent, WorksheetFormElementOption, Grid } from '@packages/models/api';
import { PressureTestGrid, SubRowGridType } from '@packages/ui/worksheet/worksheet-form-elements/pressure-test-grid';
import { useValidationField } from './hooks/useValidationField';
import AddField from './add-field';
import colors from '@packages/core/styles/colors';

const useStyles = createUseStyles({
    divider: {
        borderWidth: 2,
        borderColor: colors.grayTwo,
        paddingTop: '4px',
        paddingBottom: '4px',
    },
});

interface FormWorksheetEditPressureTestGridProps extends DraggableWorksheetFormComponent {
    onChange({
        formElementLabel,
        options,
        worksheetElementTooltip,
        formElementDescription,
        formElementPlaceholder,
        grid,
    }: {
        formElementLabel?: string;
        options?: WorksheetFormElementOption[] | undefined;
        worksheetElementTooltip?: string;
        formElementDescription?: string;
        formElementPlaceholder?: string | undefined;
        grid?: Grid[];
    }): void;
    addField: AddFieldType;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormEditPressureTestGrid: React.FC<FormWorksheetEditPressureTestGridProps> = ({
    formElementLabel,
    formElementTooltip,
    formElementDescription,
    formElementPlaceholder = '',
    grid,
    onChange,
    addField,
    setIsValid,
}) => {
    const classes = useStyles();
    const {
        fieldHandlers: { handleRequired },
        fieldErrorMessages,
        isValid,
    } = useValidationField();

    useEffect(() => {
        setIsValid(isValid);
    }, [isValid, setIsValid]);

    return (
        <>
            <AddField
                addFieldValues={addField}
                onchangeText={onChange}
                formElementTooltip={formElementTooltip}
                formElementDescription={formElementDescription}
                formElementLabel={formElementLabel}
                errorMessage={fieldErrorMessages?.questionLabel}
                handleRequired={handleRequired}
            />

            <hr className={classes.divider} />

            <PressureTestGrid cornerHeader={formElementPlaceholder} readOnly={true} rows={grid as SubRowGridType[]} />
        </>
    );
};
